import React from "react";
import "./Navbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareFacebook } from "@fortawesome/free-brands-svg-icons";
import { useViewport } from "react-viewport-hooks";

import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { HashLink } from "react-router-hash-link";
import Logo from "../Images/logohorizontalwhite.webp";

import { Link } from "react-scroll";
function Navbar({ main }) {
  const { vw, vh } = useViewport();

  return (
    <nav id="navbar">
      <div className=" row navbar__row ">
        
        <div className="navbar__info__container">
          
          {vw > 1000 ? (
            <div className="logo__container">
        
        <img
            className="navbar__logo"
            href="#"
            src={Logo}
            alt="Bliss Logo"
          />
        
            </div>
          
          
          
                
        ) : (
          <></>
        )}
        </div>
         <div className="navbar__links">
            
             
                <Link
                  className="navbar__link"
                  smooth
                  to="about-bls"
                  duration={500}
                >
                  ABOUT
                </Link>

                <Link className="navbar__link" smooth to="services" duration={500}>
                  SERVICES
                </Link>

                {vw > 1000 ? (
                  <></>      
        ) : (
          <img
            className="navbar__logo"
            href="#"
            src={Logo}
            alt="Bliss Logo"
          />
        )}
                <Link
                  className="navbar__link"
                  smooth
                  to="testimonials"
                  duration={500}
                >
                  TESTIMONIALS
                </Link>

                <Link className="navbar__link" smooth to="faq" duration={500}>
                  FAQ
                </Link>

                
       
          </div>
        
        
      </div>
      
    </nav>
  );
}

export default Navbar;
